import { format } from 'util';
import { Subject, Observable } from '@reactivex/rxjs';

import { logger as commonLogger } from '@graphistry/common';
const logger = commonLogger.createDirectLogger('streamgl');

export function setupErrorHandlers(document, window, options) {
    const logFields = {
        origin: document.location.origin,
        userAgent: window.navigator.userAgent,
        params: {
            client: options.client,
            dataset: options.dataset,
            workbook: options.workbook,
        },
    };
    // Report all unhandled JS errors, and monkey-patch console.error and console.warn to post to the report URL.
    Observable.merge(setupConsoleHandler(), setupWindowOnerrorHandler())
        .do(item => logItem({ ...item, ...logFields }))
        .retry().publish().connect();

    return options;
}

function logItem({ logFn, message, ...rest }) {
    (logger[logFn] || logger.error).call(logger, rest, message || 'Unknown client error');
}

function setupWindowOnerrorHandler() {
    const notifier = new Subject();
    window.onerror = function windowOnErrorHandler(messageOrEvent, source, lineno, colno, error) {
        const record = { type: 'JSError' };

        if (typeof messageOrEvent === 'string') {
            record.message = messageOrEvent;
        } else {
            record.message = 'Resource failed to load';
        }

        if (source || lineno || colno) {
            record.src = { file: source, line: lineno, column: colno };
        }

        if (error) {
            record.err = error;
        }

        notifier.next(record);
        return false;
    };

    return notifier;
}

function setupConsoleHandler() {
    const consoleEvents = ['error', 'warn'].map((functionName) => {
        const notifier = new Subject();
        console[functionName] = function wrappedConsoleLogger(message) {
            notifier.next({ message: format.apply(this, arguments) });
        };
        return notifier.map(({ message }) => ({ logFn: functionName, type: `console.${functionName}`, message }));
    });

    return Observable.merge(...consoleEvents);
}
